module.exports = __webpack_public_path__ + "static/lounge-6d44b6deaf675e84c1eed2bdf6381bfb.jpg";